import React from 'react';
import ProductCard from './ProductCard';

const ProductList = ({ 
  products = [], 
  isLoading = false, 
  isAdminView = false,
  onProductEdit = null,
  onProductDelete = null,
  onProductClick = null
}) => {
  if (isLoading) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '40px',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading products...
      </div>
    );
  }
  
  if (!products.length) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '60px 20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        margin: '20px 0'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px', color: '#dee2e6' }}>
          📦
        </div>
        <h3 style={{ color: '#6c757d', marginBottom: '8px' }}>
          {isAdminView ? 'No products found' : 'No products available'}
        </h3>
        <p style={{ color: '#6c757d', margin: 0 }}>
          {isAdminView 
            ? 'Start by adding your first product' 
            : 'Check back soon for new products'
          }
        </p>
      </div>
    );
  }

  return (
    <div>
      {/* Products Grid */}
      <div 
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '16px',
          padding: '16px 0'
        }}
      >
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            isAdminView={isAdminView}
            onEdit={onProductEdit}
            onDelete={onProductDelete}
            onClick={onProductClick}
          />
        ))}
      </div>
      
      {/* Product Count */}
      <div style={{
        textAlign: 'center',
        marginTop: '20px',
        padding: '16px',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        fontSize: '14px',
        color: '#6c757d'
      }}>
        Showing {products.length} product{products.length !== 1 ? 's' : ''}
      </div>
    </div>
  );
};

export default ProductList;